import { useId } from "react"

export function LandingLogoFlag({ className = "" }: { className?: string }) {
  const clipId = useId()

  return (
    <div className={`w-full flex items-center justify-center ${className}`}>
      <svg
        className="w-16 sm:w-20 md:w-24 lg:w-28 xl:w-32 h-auto"
        viewBox="0 0 124 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M68.98 39.3L66.32 53.36L117.61 49.14L114.36 66.36L61.53 70.71L64.49 55.07L14.19 59.21L13.82 59.24L13.22 59.29L11.6 59.42L13.58 62.32L6.21001 99.94L0.0100098 100.43L19.91 0.43L25.78 0L23.7 10.67L75.2 6.43L72.24 22.07L123.5 17.85L120.25 35.08L68.98 39.3ZM67.75 37.84L70.41 23.78L23.09 27.67L20.33 27.89L19.12 27.99L17.01 28.16L19.55 31.88L17.57 41.98L67.76 37.85L67.75 37.84Z"
            fill="#0000FF"
          />
        </g>
        <defs>
          <clipPath id={clipId}>
            <rect width="123.5" height="100.43" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
